/**************************************************
 * Nombre:       Portada_RG
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import BotonWhatsApp from "../../../Componentes/BotonWhatsApp";
import {Player} from 'video-react';
import 'video-react/dist/video-react.css'
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";

const Portada_RI = ({item, cupos}) => {
    const {sCell} = useResponsive()


    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, pt: 2, zIndex: 2}}
            >


                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <img src={item.imgLogo} width={sCell ? 150 : 200} height={'auto'}/>
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}} justifyContent={'flex-end'}>
                    <BotonWhatsApp numero={item.numero} />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 7}} sx={{mt: 6}}>
                    <Typography sx={{
                        color: '#000',
                        fontSize: sCell ? 40 : 56,
                        fontWeight: 800,
                        lineHeight: 0.9,
                        textAlign: 'center'
                    }}>{item.tituloPortada}</Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 7}} sx={{mt: 4}}>
                    <Typography sx={{
                        color: '#000',
                        fontSize: sCell ? 20 : 22,
                        fontWeight: 400,
                        lineHeight: 1.3,
                        textAlign: 'center'
                    }}>{item.parrafo}</Typography>
                </Grid>





            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{mt: 8}}>
                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>


                    {item.tipoPortada === 'imagen' ?
                        <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'center'}}>
                            <img src={item.imgLimitador} width={'80%'} height={'auto'}
                                 style={{borderRadius: 40}}/>
                        </Grid> :

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{
                                  justifyContent: 'center',
                                  zIndex: 4,
                                  p: sCell ? 0 : 3,
                                  //  boxShadow: 4,
                                  borderRadius: 2,
                                 // backdropFilter: 'blur(3px)',
                                  //maxHeight: 500
                              }}>
                            <Player >
                                <source src={item.videoPortada} type='video/mp4'  />
                            </Player>
                        </Grid>

                    }

                </Grid>
            </Grid>


        </Grid>
    )

}
export default Portada_RI